import { render, staticRenderFns } from "./deleted.vue?vue&type=template&id=512afe0e&scoped=true&"
import script from "./deleted.vue?vue&type=script&lang=js&"
export * from "./deleted.vue?vue&type=script&lang=js&"
import style0 from "./deleted.vue?vue&type=style&index=0&id=512afe0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512afe0e",
  null
  
)

export default component.exports